import { useLayoutEffect, useRef, useState } from 'react';
import { useEnterToSubmitContext } from './useEnterToSubmitContext';
import { getEnterToSubmitHotkey, resolveEnterToSubmitMode } from './useEnterToSubmit';

/**
 * Resolves the enter-to-submit hotkey string for display on the closest form.
 * Still returns a display string when submit is temporarily disabled (`ctx.enabled`
 * false) so the hint stays visible on disabled submit buttons.
 * Attach `ref` to an element inside the form (e.g. the actions container).
 */
export function useSubmitShortcutHotkey() {
  const ctx = useEnterToSubmitContext();
  const ref = useRef<HTMLDivElement | null>(null);
  const [hotkey, setHotkey] = useState<string | null>(null);

  useLayoutEffect(() => {
    if (!ctx || ctx.mode === false) {
      setHotkey(null);
      return;
    }

    const form = ref.current?.closest('form') ?? null;
    const resolved = resolveEnterToSubmitMode(ctx.mode, form);
    setHotkey(resolved ? getEnterToSubmitHotkey(resolved) : null);
  }, [ctx]);

  return { hotkey, ref };
}
